import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { addToStorage } from "../../config/auth.config";
import { TimelineWrapper } from "./common/TimelineWrapper";
import { sharedUserInfoStyles } from "./Styles/sharedUserInfoStyles";
import { UserDetails } from "./UserDetails";
import { PrescirberDetails } from "./PrescriberDetails";

import { useAsync } from "../common/async";
import {
  medsUserApi,
  UserType,
} from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { Box, Button } from "@material-ui/core";
import { ReactComponent as OneIcon } from "../../images/1.svg";
import { ReactComponent as TwoIcon } from "../../images/2.svg";
import { FlatButton } from "../common/FlatButton";
import { getLookups } from "../../services/medicationmanagement/userRegistration/userRegistraitionService";
import { RegistrationLookups } from "../../services/medicationmanagement/userRegistration/RegistrationLookups";
import { IdentityContext, UserIdentity } from "../auth/UserIdentity";
import { RenderIf } from "../common/render-if/RenderIf";
import { BasicUserSchema, PrescirberSchema } from "./Schema/sharedUser";
import { ISharedUserInfo } from "../../services/medicationmanagement/medsUser/models/SharedUserInfo";

const IsPresciberSharedUser = (ctx: UserIdentity | null) => {
  return useMemo(() => {
    const usertype = ctx?.userInfo?.userType;
    const res =
      usertype === UserType.Doctor ||
      usertype === UserType.NursePractitioner ||
      usertype === UserType.Dentist ||
      usertype === UserType.Optometrist;
    return res;
  }, []);
};

export const LookupsContext = createContext<RegistrationLookups | null>(null);
export const SharedUserForm = () => {
  const ctx = useContext(IdentityContext);
  const formUtils = useForm<ISharedUserInfo>({
    resolver: yupResolver(
      IsPresciberSharedUser(ctx) ? PrescirberSchema : BasicUserSchema
    ),
    mode: "onChange",
  });
  const classes = sharedUserInfoStyles();

  let { success, queryDispatcher } = useAsync();
  useEffect(() => {
    queryDispatcher(getLookups());
  }, []);

  const onSubmit = async (data: ISharedUserInfo) => {
    const response = await medsUserApi.upSertProvider(data);
    addToStorage(
      "providerId",
      `providerAuthoringSystem=${response.authoringSystem}&providerAuthoringSystemForeignKey=${response.authoringSystemForeignKey}`
    );
    window.location.reload();
  };
  return (
    <LookupsContext.Provider value={success as RegistrationLookups}>
      <Box>
        <Box className={classes.titleBig}>Additional details</Box>
        <form
          noValidate
          className={classes.form}
          onSubmit={formUtils.handleSubmit(onSubmit)}
        >
          <TimelineWrapper stepIcon={<OneIcon />} title="User details">
            <UserDetails formUtils={formUtils} />
          </TimelineWrapper>
          <RenderIf if={IsPresciberSharedUser(ctx)}>
            <TimelineWrapper stepIcon={<TwoIcon />} title="Prescriber details">
              <PrescirberDetails formUtils={formUtils} />
            </TimelineWrapper>
          </RenderIf>
          <FlatButton
            kind="primary"
            isDisabled={
              !formUtils.formState.isValid || formUtils.formState.isSubmitting
            }
            type="submit"
            css={{
              width: 168,
              margin: "40px 0",
            }}
          >
            Submit
          </FlatButton>
        </form>
      </Box>
    </LookupsContext.Provider>
  );
};
